export interface GlosarioTermItem {
  slug: string;
  term: string;
  definition: string;
  relatedSlugs?: string[];
}

export const GLOSARIO_TERMS: GlosarioTermItem[] = [
  {
    slug: "nom-035-stps-2018",
    term: "NOM-035-STPS-2018",
    definition:
      "La NOM-035-STPS-2018 es la norma oficial mexicana que establece los elementos para identificar, analizar y prevenir los factores de riesgo psicosocial en los centros de trabajo, así como para promover un entorno organizacional favorable. Es emitida por la Secretaría del Trabajo y Previsión Social (STPS) y aplica a todos los centros de trabajo del país.",
    relatedSlugs: ["stps", "factores-de-riesgo-psicosocial", "entorno-organizacional-favorable"],
  },
  {
    slug: "factores-de-riesgo-psicosocial",
    term: "Factores de riesgo psicosocial",
    definition:
      "Los factores de riesgo psicosocial son aquellas condiciones del trabajo —como cargas excesivas, jornadas prolongadas, falta de control sobre las tareas, liderazgo negativo o violencia laboral— que pueden afectar la salud mental y física de los trabajadores. La NOM-035 obliga a identificarlos y prevenirlos.",
    relatedSlugs: ["nom-035-stps-2018", "violencia-laboral", "liderazgo-negativo"],
  },
  {
    slug: "entorno-organizacional-favorable",
    term: "Entorno organizacional favorable",
    definition:
      "El entorno organizacional favorable es el conjunto de condiciones que promueven el desarrollo integral de los trabajadores: sentido de pertenencia, capacitación, definición precisa de responsabilidades, participación proactiva y distribución adecuada de cargas de trabajo. La NOM-035 obliga a promoverlo activamente.",
    relatedSlugs: ["nom-035-stps-2018", "guia-de-referencia-iii"],
  },
  {
    slug: "stps",
    term: "STPS (Secretaría del Trabajo y Previsión Social)",
    definition:
      "La STPS es la dependencia del gobierno federal mexicano encargada de vigilar el cumplimiento de la normatividad laboral, incluida la NOM-035. Es la autoridad que realiza inspecciones y puede sancionar el incumplimiento conforme a la Ley Federal del Trabajo.",
    relatedSlugs: ["nom-035-stps-2018"],
  },
  {
    slug: "guia-de-referencia-i",
    term: "Guía de Referencia I",
    definition:
      "La Guía de Referencia I es el instrumento oficial de la STPS para identificar y clasificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos durante o con motivo del trabajo, y canalizarlos a atención especializada cuando corresponde.",
    relatedSlugs: ["acontecimiento-traumatico-severo", "guia-de-referencia-ii", "guia-de-referencia-iii"],
  },
  {
    slug: "guia-de-referencia-ii",
    term: "Guía de Referencia II",
    definition:
      "La Guía de Referencia II es el cuestionario oficial de la STPS para identificar a los trabajadores expuestos a factores de riesgo psicosocial y evaluar su gravedad, aplicable a centros de trabajo de más de 15 trabajadores.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "guia-de-referencia-i", "guia-de-referencia-iii"],
  },
  {
    slug: "guia-de-referencia-iii",
    term: "Guía de Referencia III",
    definition:
      "La Guía de Referencia III es el instrumento oficial de la STPS para evaluar el entorno organizacional favorable en centros de trabajo de más de 50 trabajadores, complementando la evaluación de factores de riesgo psicosocial.",
    relatedSlugs: ["entorno-organizacional-favorable", "guia-de-referencia-ii"],
  },
  {
    slug: "acontecimiento-traumatico-severo",
    term: "Acontecimiento traumático severo",
    definition:
      "Un acontecimiento traumático severo es un evento vivido durante o con motivo del trabajo —como un accidente grave, un acto de violencia o un desastre— que puede generar en el trabajador un trastorno de estrés postraumático. La NOM-035 obliga a identificar a los trabajadores expuestos.",
    relatedSlugs: ["guia-de-referencia-i", "trabajador-expuesto"],
  },
  {
    slug: "violencia-laboral",
    term: "Violencia laboral",
    definition:
      "La violencia laboral, según la NOM-035, incluye el acoso, el hostigamiento, los actos de discriminación y otras formas de malos tratos ejercidos dentro del centro de trabajo. Identificarla y prevenirla es parte central de la evaluación de factores de riesgo psicosocial.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "liderazgo-negativo"],
  },
  {
    slug: "centro-de-trabajo",
    term: "Centro de trabajo",
    definition:
      "Un centro de trabajo es la unidad física en la que se desarrollan las actividades de una empresa u organización. Las obligaciones de la NOM-035 se determinan por el número de trabajadores en cada centro de trabajo, no por el tamaño total de la empresa.",
    relatedSlugs: ["nom-035-stps-2018"],
  },
  {
    slug: "trabajador-expuesto",
    term: "Trabajador expuesto",
    definition:
      "Un trabajador expuesto es aquel que, conforme a los resultados de las Guías de Referencia, presenta indicios de haber vivido un acontecimiento traumático severo o de estar sujeto a factores de riesgo psicosocial, y que por tanto requiere seguimiento o canalización a atención especializada.",
    relatedSlugs: ["acontecimiento-traumatico-severo", "factores-de-riesgo-psicosocial"],
  },
  {
    slug: "plan-de-accion",
    term: "Plan de acción (NOM-035)",
    definition:
      "El plan de acción es el documento formal en el que una empresa define las medidas concretas, plazos y responsables para atender los riesgos psicosociales identificados en sus evaluaciones. Es una de las piezas de evidencia que la STPS puede solicitar en una inspección.",
    relatedSlugs: ["expediente-de-cumplimiento", "medidas-de-control"],
  },
  {
    slug: "expediente-de-cumplimiento",
    term: "Expediente de cumplimiento",
    definition:
      "El expediente de cumplimiento es el conjunto de evidencia documental —política de prevención, resultados de evaluaciones, medidas de control y registros de seguimiento— que demuestra que una empresa cumple con la NOM-035. MAPA35 lo organiza de forma trazable por trabajador y por centro de trabajo.",
    relatedSlugs: ["plan-de-accion", "politica-de-prevencion-de-riesgos-psicosociales"],
  },
  {
    slug: "politica-de-prevencion-de-riesgos-psicosociales",
    term: "Política de prevención de riesgos psicosociales",
    definition:
      "Es el documento formal, difundido entre los trabajadores, en el que la empresa establece su compromiso de prevenir los factores de riesgo psicosocial y atender la violencia laboral. Su existencia y difusión es uno de los primeros requisitos que verifica la STPS.",
    relatedSlugs: ["expediente-de-cumplimiento", "factores-de-riesgo-psicosocial"],
  },
  {
    slug: "liderazgo-negativo",
    term: "Liderazgo negativo",
    definition:
      "El liderazgo negativo se refiere a relaciones de mando basadas en el abuso de autoridad, la falta de claridad en las instrucciones o la ausencia de retroalimentación constructiva. La NOM-035 lo identifica como uno de los factores que deterioran el entorno organizacional.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "violencia-laboral"],
  },
  {
    slug: "medidas-de-control",
    term: "Medidas de control (riesgo psicosocial)",
    definition:
      "Las medidas de control son las acciones específicas que una empresa implementa para reducir o eliminar los factores de riesgo psicosocial identificados en su evaluación, como ajustes en cargas de trabajo, capacitación a mandos medios o canales para atender quejas de violencia laboral.",
    relatedSlugs: ["plan-de-accion", "factores-de-riesgo-psicosocial"],
  },
  {
    slug: "comision-de-seguridad-e-higiene",
    term: "Comisión de Seguridad e Higiene",
    definition:
      "La Comisión de Seguridad e Higiene es un órgano bipartito, integrado por representantes de la empresa y de los trabajadores, encargado de investigar accidentes y condiciones inseguras en el centro de trabajo. Aunque no es exclusiva de la NOM-035, en muchas empresas participa en el seguimiento de las acciones derivadas de la evaluación de riesgo psicosocial.",
    relatedSlugs: ["ley-federal-del-trabajo", "nom-035-stps-2018"],
  },
  {
    slug: "ley-federal-del-trabajo",
    term: "Ley Federal del Trabajo (LFT)",
    definition:
      "La Ley Federal del Trabajo (LFT) es la ley que regula las relaciones laborales en México, incluidas las obligaciones patronales en materia de seguridad y salud en el trabajo. La NOM-035 desarrolla, en materia de riesgo psicosocial, obligaciones generales que ya establece esta ley, y su incumplimiento se sanciona conforme a los procedimientos que ella define.",
    relatedSlugs: ["stps", "sancion-economica"],
  },
  {
    slug: "reglamento-federal-de-seguridad-y-salud-en-el-trabajo",
    term: "Reglamento Federal de Seguridad y Salud en el Trabajo (RFSST)",
    definition:
      "El Reglamento Federal de Seguridad y Salud en el Trabajo (RFSST) es la norma que desarrolla las disposiciones de la Ley Federal del Trabajo en materia de seguridad y salud, y sirve de marco para las Normas Oficiales Mexicanas —como la NOM-035— que la STPS emite para regular riesgos específicos en los centros de trabajo.",
    relatedSlugs: ["ley-federal-del-trabajo", "norma-oficial-mexicana"],
  },
  {
    slug: "riesgo-de-trabajo",
    term: "Riesgo de trabajo",
    definition:
      "Un riesgo de trabajo es, conforme a la Ley Federal del Trabajo, un accidente o enfermedad al que están expuestos los trabajadores en ejercicio o con motivo del trabajo. Los factores de riesgo psicosocial que regula la NOM-035 son una categoría específica de riesgo de trabajo, enfocada en el impacto en la salud mental y el bienestar.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "salud-ocupacional"],
  },
  {
    slug: "carga-de-trabajo",
    term: "Carga de trabajo",
    definition:
      "La carga de trabajo es la cantidad de exigencias físicas y mentales que enfrenta un trabajador para cumplir sus funciones. Una carga de trabajo excesiva o mal distribuida es uno de los factores de riesgo psicosocial que la NOM-035 obliga a identificar y controlar.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "jornada-de-trabajo"],
  },
  {
    slug: "jornada-de-trabajo",
    term: "Jornada de trabajo",
    definition:
      "La jornada de trabajo es el tiempo durante el cual un trabajador está a disposición del patrón para prestar sus servicios. Las jornadas prolongadas o mal organizadas, incluida la rotación de turnos, forman parte de los factores de riesgo psicosocial que evalúa la NOM-035.",
    relatedSlugs: ["carga-de-trabajo", "rotacion-de-turnos"],
  },
  {
    slug: "rotacion-de-turnos",
    term: "Rotación de turnos",
    definition:
      "La rotación de turnos es el cambio periódico del horario de trabajo de un empleado, incluyendo turnos nocturnos. Cuando no está bien gestionada, puede afectar el descanso y la vida familiar del trabajador, por lo que la NOM-035 la considera dentro de los factores de riesgo relacionados con la jornada de trabajo.",
    relatedSlugs: ["jornada-de-trabajo", "interferencia-trabajo-familia"],
  },
  {
    slug: "interferencia-trabajo-familia",
    term: "Interferencia trabajo-familia",
    definition:
      "La interferencia trabajo-familia ocurre cuando las exigencias del trabajo dificultan que un empleado atienda sus responsabilidades familiares y personales, o viceversa. La NOM-035 la identifica como uno de los factores de riesgo psicosocial que las empresas deben evaluar y, en la medida de lo posible, mitigar.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "jornada-de-trabajo"],
  },
  {
    slug: "control-sobre-el-trabajo",
    term: "Control sobre el trabajo",
    definition:
      "El control sobre el trabajo es el grado de autonomía que tiene un trabajador para decidir cómo, cuándo y con qué método realiza sus tareas. La falta de control sobre el trabajo es uno de los factores de riesgo psicosocial que la NOM-035 obliga a identificar, ya que se asocia con mayor estrés y menor bienestar laboral.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "carga-de-trabajo"],
  },
  {
    slug: "relaciones-positivas-en-el-trabajo",
    term: "Relaciones positivas en el trabajo",
    definition:
      "Las relaciones positivas en el trabajo son interacciones basadas en el respeto, la comunicación clara y el apoyo mutuo entre compañeros y jefes. Promoverlas es parte de construir un entorno organizacional favorable, el objetivo opuesto a los factores como el liderazgo negativo que la NOM-035 busca prevenir.",
    relatedSlugs: ["entorno-organizacional-favorable", "liderazgo-negativo"],
  },
  {
    slug: "hostigamiento",
    term: "Hostigamiento",
    definition:
      "El hostigamiento es una forma de violencia laboral que consiste en el ejercicio de poder en una relación de subordinación real, expresado en conductas verbales o físicas dirigidas a intimidar, humillar o denigrar a un trabajador. La NOM-035 obliga a las empresas a identificarlo y a establecer mecanismos para atenderlo.",
    relatedSlugs: ["violencia-laboral", "acoso-laboral"],
  },
  {
    slug: "acoso-laboral",
    term: "Acoso laboral",
    definition:
      "El acoso laboral es una forma de violencia laboral ejercida de manera reiterada, con o sin relación jerárquica de por medio, que busca intimidar, excluir o denigrar a un trabajador. La NOM-035 lo agrupa dentro de los factores de riesgo relacionados con la violencia laboral que las empresas deben prevenir.",
    relatedSlugs: ["violencia-laboral", "hostigamiento"],
  },
  {
    slug: "discriminacion-laboral",
    term: "Discriminación laboral",
    definition:
      "La discriminación laboral es cualquier distinción, exclusión o restricción hacia un trabajador basada en motivos como su origen, género, edad o condición de salud, que le impide el goce de sus derechos laborales en igualdad de condiciones. La NOM-035 la identifica como una forma de violencia laboral que debe prevenirse.",
    relatedSlugs: ["violencia-laboral"],
  },
  {
    slug: "trastorno-de-estres-postraumatico",
    term: "Trastorno de estrés postraumático",
    definition:
      "El trastorno de estrés postraumático (TEPT) es una afectación psicológica que puede desarrollarse tras vivir o presenciar un acontecimiento traumático severo. La NOM-035 obliga a identificar a los trabajadores expuestos a este tipo de eventos y canalizarlos a atención especializada cuando corresponde.",
    relatedSlugs: ["acontecimiento-traumatico-severo", "trabajador-expuesto"],
  },
  {
    slug: "sindrome-de-desgaste-ocupacional",
    term: "Síndrome de desgaste ocupacional (burnout)",
    definition:
      "El síndrome de desgaste ocupacional, conocido como burnout, es un estado de agotamiento físico y emocional derivado de la exposición prolongada a factores de riesgo psicosocial en el trabajo. La NOM-035 no usa este término de forma literal, pero las condiciones que obliga a prevenir están directamente relacionadas con sus causas.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "carga-de-trabajo"],
  },
  {
    slug: "medidas-de-prevencion",
    term: "Medidas de prevención",
    definition:
      "Las medidas de prevención son las acciones que una empresa implementa para evitar que se materialicen los factores de riesgo psicosocial identificados, antes de que generen un daño. Se distinguen de las medidas de control, que actúan sobre riesgos ya presentes, y de las acciones correctivas, que responden a un daño ya ocurrido.",
    relatedSlugs: ["medidas-de-control", "acciones-preventivas"],
  },
  {
    slug: "acciones-correctivas",
    term: "Acciones correctivas",
    definition:
      "Las acciones correctivas son las medidas que una empresa adopta para atender un factor de riesgo psicosocial o un caso de violencia laboral que ya se presentó, con el fin de corregir la situación y evitar que se repita. Forman parte del plan de acción que exige la NOM-035.",
    relatedSlugs: ["plan-de-accion", "acciones-preventivas"],
  },
  {
    slug: "acciones-preventivas",
    term: "Acciones preventivas",
    definition:
      "Las acciones preventivas son las medidas que una empresa adopta de forma anticipada para reducir la probabilidad de que se presente un factor de riesgo psicosocial, antes de que cause un daño a los trabajadores. Se documentan como parte del plan de acción de la NOM-035.",
    relatedSlugs: ["plan-de-accion", "medidas-de-prevencion"],
  },
  {
    slug: "seguimiento-anual",
    term: "Seguimiento anual",
    definition:
      "El seguimiento anual es la revisión periódica que la NOM-035 exige para mantener actualizado el diagnóstico de riesgo psicosocial de una empresa, verificar si las medidas adoptadas funcionaron y ajustar el plan de acción según cambien las condiciones de trabajo.",
    relatedSlugs: ["plan-de-accion", "expediente-de-cumplimiento"],
  },
  {
    slug: "difusion-de-la-politica-de-prevencion",
    term: "Difusión de la política de prevención",
    definition:
      "La difusión de la política de prevención es la obligación de dar a conocer a todos los trabajadores el documento en el que la empresa establece su compromiso de prevenir los factores de riesgo psicosocial. Sin esta difusión, la política no cumple su propósito ni satisface lo que exige la NOM-035.",
    relatedSlugs: ["politica-de-prevencion-de-riesgos-psicosociales", "capacitacion-en-nom-035"],
  },
  {
    slug: "capacitacion-en-nom-035",
    term: "Capacitación en NOM-035",
    definition:
      "La capacitación en NOM-035 es el proceso mediante el cual una empresa da a conocer a sus trabajadores la política de prevención, los factores de riesgo identificados y las medidas de control adoptadas, para que el entorno organizacional favorable se traduzca en prácticas conocidas por todos, no solo en un documento.",
    relatedSlugs: ["difusion-de-la-politica-de-prevencion", "entorno-organizacional-favorable"],
  },
  {
    slug: "diagnostico-organizacional",
    term: "Diagnóstico organizacional",
    definition:
      "El diagnóstico organizacional es la primera etapa del proceso de cumplimiento de la NOM-035: un análisis del estado actual de una empresa frente a los requisitos de la norma, que permite identificar qué evaluaciones, expedientes y medidas hacen falta antes de construir el plan de acción.",
    relatedSlugs: ["plan-de-accion", "expediente-de-cumplimiento"],
  },
  {
    slug: "expediente-por-trabajador",
    term: "Expediente por trabajador",
    definition:
      "El expediente por trabajador es el conjunto de evidencia documental asociada a un empleado en particular, como los resultados de sus evaluaciones o su condición de trabajador expuesto. Es una de las dos unidades, junto con el expediente por centro de trabajo, en las que MAPA35 organiza el expediente de cumplimiento.",
    relatedSlugs: ["expediente-de-cumplimiento", "trabajador-expuesto"],
  },
  {
    slug: "expediente-por-centro-de-trabajo",
    term: "Expediente por centro de trabajo",
    definition:
      "El expediente por centro de trabajo es el conjunto de evidencia documental asociada a una unidad física de la empresa —su política de prevención, sus evaluaciones agregadas, su plan de acción—, distinto del expediente por trabajador que documenta la situación de cada empleado en particular.",
    relatedSlugs: ["expediente-de-cumplimiento", "centro-de-trabajo"],
  },
  {
    slug: "cuestionario-de-evaluacion-del-entorno-organizacional",
    term: "Cuestionario de evaluación del entorno organizacional",
    definition:
      "El cuestionario de evaluación del entorno organizacional es el instrumento, basado en la Guía de Referencia III, que se aplica a los trabajadores de centros de trabajo de más de 50 empleados para medir si existen las condiciones que promueven su desarrollo integral.",
    relatedSlugs: ["guia-de-referencia-iii", "entorno-organizacional-favorable"],
  },
  {
    slug: "factor-de-riesgo",
    term: "Factor de riesgo",
    definition:
      "Un factor de riesgo es cualquier condición del entorno o de la organización del trabajo que incrementa la probabilidad de que ocurra un daño a la salud de los trabajadores. Los factores de riesgo psicosocial que regula la NOM-035 son una categoría específica, centrada en el impacto en la salud mental y el bienestar.",
    relatedSlugs: ["factores-de-riesgo-psicosocial", "peligro"],
  },
  {
    slug: "peligro",
    term: "Peligro",
    definition:
      "Un peligro es la fuente o situación con capacidad de causar un daño, mientras que el riesgo es la probabilidad de que ese daño realmente ocurra bajo ciertas condiciones. La NOM-035 se enfoca en gestionar el riesgo psicosocial derivado de peligros como una carga de trabajo excesiva o un liderazgo negativo, no en eliminar por completo su fuente.",
    relatedSlugs: ["factor-de-riesgo", "factores-de-riesgo-psicosocial"],
  },
  {
    slug: "inspeccion-laboral",
    term: "Inspección laboral",
    definition:
      "Una inspección laboral es una visita que realiza la STPS a un centro de trabajo para verificar el cumplimiento de la normatividad laboral, incluida la NOM-035. Durante la inspección, la empresa debe presentar la evidencia documental de su expediente de cumplimiento.",
    relatedSlugs: ["stps", "acta-de-inspeccion"],
  },
  {
    slug: "acta-de-inspeccion",
    term: "Acta de inspección",
    definition:
      "El acta de inspección es el documento oficial que levanta el inspector de la STPS al término de una inspección laboral, en el que registra sus observaciones y, en su caso, los requerimientos que la empresa debe atender para corregir el incumplimiento detectado.",
    relatedSlugs: ["inspeccion-laboral", "requerimiento-de-la-stps"],
  },
  {
    slug: "requerimiento-de-la-stps",
    term: "Requerimiento de la STPS",
    definition:
      "Un requerimiento de la STPS es la instrucción formal que la autoridad emite a una empresa, generalmente tras una inspección, para que corrija un incumplimiento detectado dentro de un plazo determinado. No atenderlo puede derivar en una sanción económica.",
    relatedSlugs: ["acta-de-inspeccion", "sancion-economica"],
  },
  {
    slug: "sancion-economica",
    term: "Sanción económica (NOM-035)",
    definition:
      "Una sanción económica es la multa que la STPS puede imponer a una empresa que incumple la normatividad laboral, incluida la NOM-035, conforme a los criterios que establece la Ley Federal del Trabajo. Su monto varía según la gravedad y reincidencia del incumplimiento.",
    relatedSlugs: ["ley-federal-del-trabajo", "requerimiento-de-la-stps"],
  },
  {
    slug: "norma-oficial-mexicana",
    term: "Norma Oficial Mexicana (NOM)",
    definition:
      "Una Norma Oficial Mexicana (NOM) es una regulación técnica de carácter obligatorio, emitida por una dependencia del gobierno federal, que establece reglas, especificaciones o procedimientos en una materia específica. La NOM-035-STPS-2018 es la norma que, en materia laboral, regula específicamente los factores de riesgo psicosocial.",
    relatedSlugs: ["nom-035-stps-2018", "stps"],
  },
  {
    slug: "salud-ocupacional",
    term: "Salud ocupacional",
    definition:
      "La salud ocupacional es el campo dedicado a proteger y promover el bienestar físico, mental y social de los trabajadores en su entorno laboral. La NOM-035 forma parte de este campo, enfocada específicamente en la dimensión psicosocial de la salud en el trabajo.",
    relatedSlugs: ["riesgo-de-trabajo", "factores-de-riesgo-psicosocial"],
  },
  {
    slug: "clima-organizacional",
    term: "Clima organizacional",
    definition:
      "El clima organizacional es la percepción compartida que tienen los trabajadores sobre el ambiente en el que laboran: el estilo de liderazgo, la comunicación, el reconocimiento y las relaciones entre compañeros. Un clima organizacional saludable es, en la práctica, uno de los resultados esperados de construir un entorno organizacional favorable.",
    relatedSlugs: ["entorno-organizacional-favorable", "relaciones-positivas-en-el-trabajo"],
  },
];
